<!-- <div class="loading-container">
    <mat-spinner diameter="40"></mat-spinner>
</div> -->

<div class="spinner">
  <div class="spinner__content">
    <rx-icon name="icon-spinner"></rx-icon>
  </div>
  <div class="spinner__backdrop"></div>
</div>
